/**
 * @desc directive that prevents user from inputting spaces and special characters, allowing only alphanumeric characters
 */

(function() {
	'use strict';

	angular
        .module('directives')
        .directive('noSpaceSpecial', noSpaceSpecial);

	function noSpaceSpecial() {
		var directive = {
			link: link,
			scope: true,
			restrict: 'A'
		};
		return directive;

		function link(scope, element, attrs, ctrl) {
			element.on('keypress', function(event) {
				var value = event.key;
				if (!validateInput(value)) {
					event.preventDefault();
					return false;
				}
				return true;
			});

			element.on('keyup', function(event) {
				if (event.target.value !== '' && !validateInput(event.target.value)) {
					jQuery('#' + event.target.id).addClass('has-error');
				} else {
					jQuery('#' + event.target.id).removeClass('has-error');
				}
				scope.$apply();
			});

			element.on('paste', function(event) {
				setTimeout(function() {
					if (event.target.value !== '' && !validateInput(event.target.value)) {
						jQuery('#' + event.target.id).addClass('has-error');
					} else {
						jQuery('#' + event.target.id).removeClass('has-error');
					}
					scope.$apply();
				}, 0);
			});

			function validateInput(value) {
				return /^[a-zA-Z0-9]*$/.test(value);
			}
		}
	}
})();
